import React from 'react'

function WindowFSG() {
  return (
    <embed src="\pdfs\E1.2.5_FSG_Window_air_curtain_unit_04.2014_kr.pdf" width="100%" height="2100px" />
  )
}

export default WindowFSG